import { render } from "./ChangeUserRoleDialog.vue?vue&type=template&id=c06e0f06&scoped=true&ts=true&lang=pug"
import script from "./ChangeUserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeUserRoleDialog.vue?vue&type=script&lang=ts"

import "./ChangeUserRoleDialog.vue?vue&type=style&index=0&id=c06e0f06&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06e0f06"]])

export default __exports__